import { CloseBold, NavigationMenuBold } from '@ha/icons';
import React from 'react';
import { makeStyles } from '@material-ui/core';

import { SearchBar } from 'ha/modules/SearchBar';
import { Grid, IconButton, Slide, SwipeableDrawer, units } from '@ha/dsl';

import AdvertiserLogo from './AdvertiserLogo';
import AppBarMobile from './AppBarMobile';
import NavBarLogo from './NavBarLogo';
import { MobileMenuType } from '../types';
import MobileMainMenu from '../containers/MobileMainMenu';
import MobilePaymentMenu from '../containers/MobilePaymentMenu.lazy';

const useStyles = makeStyles(theme => ({
  actionButton: {
    color: theme.palette.grey[500],
    marginLeft: 'auto',
  },
  darkBlueMain: {
    color: theme.palette.grey[700],
  },
  searchBar: {
    marginLeft: units.rem(1),
    marginRight: units.rem(1),
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      width: units.rem(20),
      flexGrow: 'initial',
    },
  },
}));

interface Props {
  currentMenu: MobileMenuType;
  isDrawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  showSearchBar?: boolean;
  searchBarElement?: React.ReactNode;
  showMobileDrawerMenu?: boolean;
  showLogo?: boolean;
  advertiserLogo?: string;
}

export const NavBarMobile: React.FC<Props> = ({
  currentMenu,
  isDrawerOpen,
  openDrawer,
  closeDrawer,
  showSearchBar,
  searchBarElement,
  showMobileDrawerMenu,
  showLogo,
  advertiserLogo,
}) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <AppBarMobile>
        <Grid alignItems="center" container wrap="nowrap">
          <Grid item>
            {advertiserLogo && <AdvertiserLogo url={advertiserLogo} />}
            {showLogo && <NavBarLogo showOnlyIcon={showSearchBar} />}
          </Grid>

          {showSearchBar && (
            <Grid item className={classes.searchBar}>
              {searchBarElement || <SearchBar />}
            </Grid>
          )}
          <Grid item className={classes.actionButton}>
            <IconButton onClick={openDrawer} size="small">
              <NavigationMenuBold fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
      </AppBarMobile>
      <SwipeableDrawer
        anchor="right"
        open={isDrawerOpen}
        onOpen={openDrawer}
        onClose={closeDrawer}
        hideBackdrop
        disableBackdropTransition
        fullWidth
      >
        <AppBarMobile>
          <Grid alignItems="center" justify="space-between" container>
            <Grid item>
              {advertiserLogo && <AdvertiserLogo url={advertiserLogo} />}
              {showLogo && <NavBarLogo showOnlyIcon={showSearchBar} />}
            </Grid>
            <Grid item className={classes.actionButton}>
              <IconButton
                onClick={closeDrawer}
                size="small"
                data-test-locator="NavBar Close Button"
              >
                <CloseBold fontSize="inherit" />
              </IconButton>
            </Grid>
          </Grid>
        </AppBarMobile>

        <Slide
          unmountOnExit
          direction="right"
          in={currentMenu === MobileMenuType.main}
          exit={false}
        >
          <div className={classes.darkBlueMain}>
            <MobileMainMenu showDrawerMenu={showMobileDrawerMenu} />
          </div>
        </Slide>

        <Slide
          unmountOnExit
          direction="left"
          in={currentMenu === MobileMenuType.payment}
          exit={false}
        >
          <div className={classes.darkBlueMain}>
            <MobilePaymentMenu />
          </div>
        </Slide>
      </SwipeableDrawer>
    </React.Fragment>
  );
};

export default NavBarMobile;
